import _get from 'lodash/get';
import { constants } from '@/lib/constants';
import { post } from '@/lib/utils';


const localActions = {
  buildRecentSalesParams({ rootGetters }) {
    const { CURRENT_DATE, DELIM, EQUALS } = constants;

    let qry = '';
    const RecentOrderDaysValue = _get(rootGetters['preferences/getPreference']('RecentOrderDays'), 'preference.value', '');
    qry += `orderdate-GE${CURRENT_DATE}-${(RecentOrderDaysValue) || '15'}${DELIM}status-NEV${DELIM}`;
    qry += `or(type-EQSAL${DELIM}type-EQRES${DELIM})`;
    if (rootGetters['permissions/isPermPresent']('orderrecentallusers')) {
      qry += `ordersiteid-${EQUALS}${rootGetters['auth/loggedInSiteId']}`;
    } else {
      const username = rootGetters['auth/username'];
      qry += `or(salesperson1-${EQUALS}${username}${DELIM}salesperson2-${EQUALS}${username}${DELIM})`;
    }
    return qry;
  },

  async getRecentSales({ dispatch }) {
    const uql = await dispatch('buildRecentSalesParams');

    const params = {
      limit: 10,
      orderby: 'orderdate-,ordertime-,orderid',
      q: uql,
    };

    const { results } = await post('/tg/order/query', params);
    return results;
  },

  buildAssignedTasksParams({ rootGetters }) {
    const { DB_TRUE, CURRENT_DATE, DELIM, EQUALS } = constants;

    const username = rootGetters['auth/username'];
    const newestFirst = _get(rootGetters['preferences/getPreference']('NewestTasksFirst'), 'preference.value', '') === DB_TRUE;
    const RecentTaskDays = _get(rootGetters['preferences/getPreference']('RecentTaskDays'), 'preference.value', '');
    let limit = _get(rootGetters['preferences/getPreference']('MaxTaskDisplay'), 'preference.value', '');

    let orderby = '';
    let qry = '';
    qry = `notifyby-LE${CURRENT_DATE}+${RecentTaskDays}${DELIM}`;
    const includeOtherTasks = _get(rootGetters['preferences/getPreference']('IncludeOtherUserTasks'), 'preference.value', '') === DB_TRUE;
    if (includeOtherTasks && rootGetters['permissions/isPermPresent']('taskrecentallusers')) {
      qry += `or(assignedsiteid-${EQUALS}${rootGetters['auth/loggedInSiteId']}${DELIM}assignedto-${EQUALS}${username}${DELIM})`;
    } else {
      qry += `assignedto-${EQUALS}${username}${DELIM}`;
      // Danger of never seeing old tasks, so, for now, no limit:
      if (newestFirst) limit = 'None';
    }

    qry += `or(status-${EQUALS}A${DELIM}status-${EQUALS}P${DELIM})`;

    const optionalDash = newestFirst ? '-' : '';
    orderby = `assignedto,notifyby${optionalDash},mainorderid,sequence${optionalDash}`;

    return { qry, limit, orderby };
  },

  async getAssignedTasks({ dispatch }) {
    const { qry: uql, limit, orderby } = await dispatch('buildAssignedTasksParams');
    const params = { q: uql, limit, orderby };
    const { results } = await post('/tg/ordertask/query', params);
    return results;
  },
};
export default {
  namespaced: true,
  actions: localActions,
};
